import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <div className="relative overflow-hidden pt-32 pb-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative z-10">
          <div className="text-center">
            <div className="flex items-center justify-center mb-8">
              <div className="bg-blue-100 p-2 rounded-lg">
                <span className="text-sm font-medium text-blue-800">
                  Limited Time: 70% OFF! 🎉🎉🎉 Sign up now to receive a $10 trial credit! 😊😊😊
                </span>
              </div>
            </div>
            <h1 className="text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl mb-8">
              Unified LLM Interface
              <br />
              <br />
              <span className="text-blue-600">
                20% Lower Than Official Prices
              </span>
            </h1>
            <p className="mt-6 text-xl text-gray-600 max-w-2xl mx-auto">
              Access 100+ large language models through a single, cost-effective
              API. Save on every request while maintaining enterprise-grade
              reliability.
            </p>
            <div className="mt-10 flex items-center justify-center">
              <button className="bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center">
                Get Started <ArrowRight className="ml-2 h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-blue-50/50 via-gray-50 to-white" />
      </div>
    </div>
  );
}